module.exports = __webpack_public_path__ + "static/media/delete.eef93cc8.svg";